const modal_gallery = document.getElementById("modal-gallery");

if (modal_gallery) {
  const main_swiper = modal_gallery.querySelector(".main-swiper swiper-container");
  const thumb_swiper = modal_gallery.querySelector(".thumb-swiper swiper-container");

  const btn_close = modal_gallery.querySelector(".btn-close");
  const btn_prev = modal_gallery.querySelector(".btn.prev");
  const btn_next = modal_gallery.querySelector(".btn.next");

  //% Init Swipers
  //$ main swiper
  swiper_init(main_swiper, {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    grabCursor: true,
    spaceBetween: 15,
    navigation: {
      prevEl: btn_prev,
      nextEl: btn_next,
    },
    on: {
      slideChange(swiper) {
        //% Exit function if the strip swiper is not visible [mobile]
        if (!thumb_swiper.swiper) {
          return;
        }
        //% Get slide index
        const index = swiper.realIndex;

        //% Store strip swiper slides in array
        const strip_slides = Array.from(thumb_swiper.children);

        //% Remove active class from all strip slides
        strip_slides.forEach((slide) => {
          slide.classList.remove("active");
        });

        //% Add active class to the new active slide
        strip_slides[index].classList.add("active");

        //% Slide to active index
        thumb_swiper.swiper.slideTo(index);
      },
    },
  });

  //$ thumb swiper
  swiper_init(thumb_swiper, {
    slidesPerView: "auto",
    spaceBetween: 15,
    breakpoints: {},
    on: {
      init(swiper) {
        // Exit if there are no slides ( like on mobile when display is none )
        if (!swiper.slides.length) return;
        //% Set first slide to active on init
        swiper.slides[0].classList.add("active");
      },

      click(swiper, event) {
        const target = event.target;
        const slides = swiper.slides;
        const index = swiper.clickedIndex;

        if (index !== undefined) {
          //% Set active slide to clicked slide on both slides
          main_swiper.swiper.slideToLoop(index);
          swiper.slideTo(index);

          //% Remove active state from all slides
          slides.forEach((slide) => {
            slide.classList.remove("active");
          });

          //% Set click slide to active
          target.classList.add("active");
        }
      },
    },
  });

  //% Trigger unmount event when close button is clicked
  btn_close.onclick = () => {
    triggerEvent(window, "gallery_unmount");
  };

  //% Handle Gallery Mount Event
  window.addEventListener("gallery_mount", () => {
    modal_gallery.classList.add("open");

    //% Set focus to gallery modal
    modal_gallery.focus();

    //% Disable window scroll
    triggerEvent(window, "scroll_stop");
  });

  //% Handle Gallery Unmount Event
  window.addEventListener("gallery_unmount", () => {
    modal_gallery.classList.remove("open");

    //% Enable window scroll
    triggerEvent(window, "scroll_start");
  });

  //% Add keyboard control events for lightbox
  modal_gallery.onkeyup = () => {
    if (!modal_gallery.classList.contains("open")) {
      return;
    }
    switch (event.key) {
      case "Escape": {
        triggerEvent(window, "gallery_unmount");
        break;
      }
      case "ArrowRight": {
        main_swiper.swiper.slideNext();
        break;
      }
      case "ArrowLeft": {
        main_swiper.swiper.slidePrev();
        break;
      }
      default: {
        break;
      }
    }
  };
}


